import { Component, AfterViewInit } from '@angular/core';

@Component({
  selector: 'tabs-view',
  template: `<ng-content></ng-content>`,
  styles: [
    `
      :host{
        display: block;
        height:100%;
        width: 100%;
        min-height: 70vh;
      }
    `
  ]
})
export class TabsViewComponent implements AfterViewInit {
  ngAfterViewInit() {}
}



// WEBPACK FOOTER //
// ./src/app/modules/tabs/tab-view.component.ts